import { Controller } from "@hotwired/stimulus";

// Lightweight modal lifecycle for the custom-fields editor.
// The modal markup is loaded into a turbo_frame; this controller wires
// the close behaviour (ESC, overlay click, X button), focus trap on first
// input, and emits a `cf:closed` event on the document so siblings can
// react (e.g. cleaning state after a save).
export default class extends Controller {
  static values = { locked: { type: Boolean, default: false } };

  connect() {
    this._onKey = this._onKey.bind(this);
    document.addEventListener("keydown", this._onKey);
    this._lockBodyScroll(true);
    this._focusFirst();
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKey);
    this._lockBodyScroll(false);
  }

  requestClose(event) {
    if (event) event.preventDefault();
    this.close();
  }

  close() {
    const frame = document.getElementById("cf_modal_frame");
    if (frame) frame.innerHTML = "";
    document.dispatchEvent(new CustomEvent("cf:closed"));
  }

  _onKey(event) {
    if (event.key === "Escape") {
      event.preventDefault();
      this.close();
    }
  }

  _lockBodyScroll(lock) {
    if (lock) {
      this._previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = this._previousOverflow || "";
    }
  }

  _focusFirst() {
    requestAnimationFrame(() => {
      const target = this.element.querySelector("input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled])");
      if (target) target.focus();
    });
  }
}
